'use client';

import React from 'react';
import { Info } from 'lucide-react';

/**
 * Small, visible AI usage disclaimer shown on the chat start screen and above the chat input.
 * Friendly tone: encourages double-checking without sounding alarming.
 */
export function AiDisclaimerBanner() {
  return (
    <div
      className="flex items-center justify-center gap-2 py-2 px-3 text-xs text-muted-foreground bg-muted/30"
      role="status"
      aria-live="polite"
    >
      <Info className="w-3.5 h-3.5 shrink-0 text-muted-foreground" aria-hidden />
      <span>AI can be wrong sometimes—double-check anything important.</span>
    </div>
  );
}
